import { render } from "./HowItWorks.vue?vue&type=template&id=6ad7aba4&scoped=true"
import script from "./HowItWorks.vue?vue&type=script&lang=js"
export * from "./HowItWorks.vue?vue&type=script&lang=js"

import "./HowItWorks.vue?vue&type=style&index=0&id=6ad7aba4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad7aba4"]])

export default __exports__